import { api } from '../api';
import { invalidator, provider, tags } from '../tags';
import type { Application, operations } from '../types';

/* istanbul ignore file */

export type CreateArgs = {
  application: operations['createApplication']['requestBody']['content']['application/json'];
  sessionId: string;
};
export type DeleteArgs = operations['destroyApplication']['parameters']['path'];

export const applicationApi = api.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    applications: builder.query<Array<Application>, void>({
      query: () => 'api/application/',
      providesTags: provider<Application>(tags.application),
    }),

    createApplication: builder.mutation<Application, CreateArgs>({
      query: ({ application, sessionId }) => ({
        url: 'api/application/',
        method: 'POST',
        body: {
          ...application,
        },
        headers: {
          'x-ovdf-session-id': sessionId,
        },
      }),
      invalidatesTags: invalidator<Application, CreateArgs>(tags.application, 'id'),
    }),

    destroyApplication: builder.mutation<void, DeleteArgs>({
      query: ({ id }) => ({
        url: `api/application/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: invalidator<void, DeleteArgs>(tags.application, undefined, 'id'),
    }),
  }),
});
